import MainComponent from "components/Main";

import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";
import ButtonIcon from "components/ButtonIcon";
import Search from "components/Search";

import AddNewItems from "pages/price/components/addNewItems";

import Row from "./components/Row";
import Category from "./components/Category";

import './index.less';
import './themes/default.less';
import dt from './data.js';

import { ReactComponent as DragIcon } from 'icons/components/drag.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as CheckIcon } from 'icons/components/check.svg';

import moveable from "actions/moveable";

export default class PriceLists extends MainComponent {

    constructor(props) {
        super(props);

        this.priceNodes = {};

        this.itemsViewPrice = [
            { name: "price.createPrice", onClick: null },
            { name: "price.download", onClick: this.downloadXlsx.bind(this) },
            { name: "expenses.print", onClick: this.printShow.bind(this, "Price_list", {}) },
            { name: "client.delete", onClick: null },
        ];

        this.itemsEditPrice = [
            { name: "price.changeDate", onClick: null },
            { name: "price.changeAllPrices", onClick: this.props.openDialog.bind(this, "changePrice") },
            { name: "price.changeSecPrices", onClick: this.props.openDialog.bind(this, "changePrice") },
            { line: true },
            { name: "price.showChange", onClick: null },
        ];

        this.state = {
            ...this.state,
            modePrice: "view",
            searchPlaceHolder: "price.findPosition",
            searchWord: "",
            root: {},
            currentMenu: { id: false, items: [] },
            currentItems: [],
            selectedMenu: false,
            editRows: {},
            priceListId: false,
            prices: this.props.prices,
            draggedRowIndex: null,
            draggedRowId: null,
            enableDrag: false,
        };
    }

    componentDidMount() {
        const { prices } = this.props;
        let { selectedMenu } = this.state;

        let currentItems = [];

        if (prices[0]?.items.length > 0) {
            dt.setup(prices);
            let index = 0;
            if (selectedMenu) {
                index = prices[0].items.findIndex(it => it.id === selectedMenu);
                index = index === -1 ? 0 : index;
            }
            selectedMenu = prices[0].items[index].id;
            currentItems = prices[0].items[index].items;
        }

        const { id, mode } = this._helper.getUrlOptions();
        if (id) {
            this.state.priceListId = id;
            this.state.modePrice = mode;
        }

        this.originalPrice = prices;

        this.setState({ selectedMenu, currentItems });

    }

    downloadXlsx() {
        const { prices } = this.state;
        const { currentInfo } = this.props;
        const { validity } = currentInfo;

        this.props.downloadXlsx(prices[0].items, validity);
    }

    updateObject(obj, newObj) {
        if ((newObj.tempId && obj.tempId === newObj.tempId) || (newObj.id && obj.id === newObj.id)) {
            return { ...obj, ...newObj };
        }

        if (Array.isArray(obj.items)) {
            for (let i = 0; i < obj.items.length; i++) {
                let updated = this.updateObject(obj.items[i], newObj);
                if (updated !== obj.items[i]) {
                    obj.items[i] = updated;
                    return obj;
                }
            }
        }

        return obj;
    }

    updateItems(newValue) {
        const { selectedMenu } = this.state;
        const currentItems = newValue.items.find(it => it.id === selectedMenu).items;
        this.setState({ currentItems });
    }

    addSection(item) {
        this.updateItems(dt.addSection(item));
    }

    changeNameSection(section) {
        this.updateItems(dt.changeNameSection(section));
    }

    addItem(newItems) {
        this.updateItems(dt.addPriceItems(newItems));
    }

    checkScroll = () => {
        const cont = document.querySelector(".blockSave");
        if (cont && this.itemsPrice) {
            const hasScroll = this.itemsPrice.scrollHeight > this.itemsPrice.clientHeight;
            if (hasScroll)
                this._helper.dom.addRemoveClass(cont, "hasScroll", true);
            else
                this._helper.dom.addRemoveClass(cont, "hasScroll", false);
        }
    };

    changeCurrentMenu(selectedMenu, currentItems) {
        this.setState({ selectedMenu, currentItems });
    }

    deleteCat(id) {
        this.deleteItem(id);
    }

    copyItem(id) {
        this.updateItems(dt.copyItem(id));
    }

    deleteItem(id) {
        this.updateItems(dt.deleteItem(id));
    }

    toggleEditRow(event, id, mode) {
        const { editRows } = this.state;
        if (event === "+") {
            this.changeState("editRows", { ...editRows, [id]: mode });
        } else {
            delete editRows[id];
            this.changeState("editRows", { ...editRows });
        }
    }

    getItemsSearch(word, itemsIn) {
        return itemsIn.reduce((acc, it) => {
            if (it.altCode) {
                if (it.altCode.toLowerCase().includes(word) || it.name.toLowerCase().includes(word))
                    acc.push(it);
            } else {
                acc = [...acc, ...this.getItemsSearch(word, it.items)];
            }
            return acc;
        }, []);

    }

    changeItemsGroup(items, id, idStart, ind1, ind2) {
        return items.map(it => {
            if (it.items.length > 0) { // есть значения
                ind1 = it.items.findIndex(item => item.id === idStart);
                ind2 = it.items.findIndex(item => item.id === id);
                if (ind1 !== -1 && ind2 !== -1)
                    [it.items[ind1], it.items[ind2]] = [it.items[ind2], it.items[ind1]];

                it.items = this.changeItemsGroup(it.items, id, idStart);
            }
            return it;
        });
    }

    isObjectsEqual(prices) {
        const ignored = ['saveChange', 'copyItem', 'deleteItem', 'dragend', 'renderPriceCat',
            'convertGroup', 'onDragOver', 'onDragStart', 'onDrop', 'onEnableDrag',
            'onDisableDrag', 'categoryTitle'];
        const objEqual = this._helper.object.isObjectsEqual(this.originalPrice, prices, ignored);
        return objEqual;
    }

    async savePriceList() {
        const prices = dt.getPrice();
        const objEqual = this.isObjectsEqual(prices);

        if (!objEqual) {
            const { loadPrices } = this.props;

            this._helper.showLoading();
            await this._request.priceCategories.update(prices[0].id, prices[0]);
            await loadPrices();
            this._helper.hideLoading();
        }

        this._helper.showNotify("price.savingPriceList", "price.successfullySaved");
    }

    outPrice() {
        const { toggleMode } = this.props;
        this.savePriceList();
        toggleMode();
        window.history.replaceState(null, null, window.location.href.split('#')[0]);
    }

    confirmNo() {
        const { toggleMode } = this.props;
        toggleMode();
        window.history.replaceState(null, null, window.location.href.split('#')[0]);
    }

    onOutPriceConfirm() {
        this._helper.confirm(
            { title: "Прайс лист изменен", message: this.tr("Вы хотите сохранить прайс лист?") },
            this.outPrice.bind(this), this.confirmNo.bind(this)
        );
    }

    onOutPrice() {
        const { toggleMode } = this.props;
        const { searchWord } = this.state;

        if (searchWord) {
            this.search.value = "";
            return this.setState({ searchWord: "" });
        }

        const prices = dt.getPrice();
        const objEqual = this.isObjectsEqual(prices);

        if (!objEqual) {
            this.onOutPriceConfirm();
        } else {
            toggleMode();
            window.history.replaceState(null, null, window.location.href.split('#')[0]);
        }
    }

    saveChange(info, mode) {
        const id = info.id || info.tempId;

        if (mode === "all") {
            info.altCode = info.editCode;
            info.name = info.editName;
            info.value = info.editSum;
        }

        if (mode === "cat")
            info.name = this[`inpname${id}`].value;
        else
            info.value = info.editSum;

        //this.updateItem(info);
        this.updateItems(dt.changeDataRow(info.editCode, info.editName, info.editSum, id));

        this.toggleEditRow("-", id, "");
    }

    convertGroup(id) {
        const res = dt.convertGroup(id);
        this.updateItems(res);
    }

    getDragAfterElement(container, y) {
        const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')];

        return draggableElements.reduce((closest, child) => {
            const box = child.getBoundingClientRect();
            const offset = y - box.top - box.height / 2;
            if (offset < 0 && offset > closest.offset) {
                return { offset: offset, element: child };
            }
            return closest;
        }, { offset: Number.NEGATIVE_INFINITY }).element;
    }

    dragend() {
        this.state.draggedRowIndex = null;
    }

    onDragStart(index, id) {
        this.state.draggedRowIndex = index;
        this.state.draggedRowId = id;
    }

    onDrop() {
        this.state.draggedRowIndex = null;
        this.setState({ draggedRowIndex: null, enableDrag: false });
    }

    onEnableDrag() {
        this.changeState("enableDrag", true);
    }

    onDisableDrag() {
        this.changeState("enableDrag", false);
    }

    onDragOver(index, e) {
        const { draggedRowIndex, draggedRowId } = this.state;
        e.preventDefault();

        if (draggedRowIndex === index) {
            return;
        }

        this.updateItems(dt.moveRows(draggedRowIndex, index, draggedRowId));
        this.changeState("draggedRowIndex", index);
    }

    async onStageIndexChange(info, index) {
    }

    _indexChangeStart(source, e) {
        moveable.setup(e, source, this.onStageIndexChange.bind(this, {}));
    }

    renderEditButton(info, editRows) {
        const id = info.id || info.tempId;
        return (<div className="buttEdit flex">
            <div className="flex1 flex centerH centerV hand" onClick={this.toggleEditRow.bind(this, "-", id, "all")}><CloseIcon /></div>
            <div className="flex1 flex centerH centerV hand" onClick={this.saveChange.bind(this, info, editRows[id])}><CheckIcon /></div>
        </div>);
    }

    renderFindPos(item, key) {
        const { items, name } = item;
        return (<div className="flex col" key={"pos" + key}>
            <div className="titleCat rad4 text p1SemiBold flex1">{name} <span className="text p1">{`(${items.length})`}</span></div>
            <div className="contentFindPos rad8">{items.map((it, i) => this.renderPriceItem(it))}</div>
        </div>);
    }

    renderFind() {
        const { prices, searchWord } = this.state;
        const word = searchWord.toLowerCase();

        const menu = prices[0].items.map(it => {
            return { name: it.name, items: this.getItemsSearch(word, it.items) };
        })?.filter((it) => it.items.length > 0);

        return (<div className="flex col gap16">{menu.length > 0 ? menu.map((it, key) => this.renderFindPos(it, key)) : <div>Поизиции не найдены</div>}</div>);
    }

    renderDragButt(source, id) {
        return (<div
            className="drag move"
            onMouseDown={this.onEnableDrag.bind(this, id)}
            onMouseUp={this.onDisableDrag.bind(this, id)}
        >
            <DragIcon />
        </div>);
        /* onMouseDown={this._indexChangeStart.bind(this, source)} */
    }

    renderPriceCat(info, key, parentItem) {
        const { modePrice } = this.state;
        const { items, isGroup } = info;

        if (!isGroup && !items?.length)
            return this.renderPriceItem({ ...info, key, parentItem });

        info.saveChange = this.saveChange.bind(this);
        info.copyItem = this.copyItem.bind(this);
        info.deleteItem = this.deleteItem.bind(this);
        info.dragend = this.dragend.bind(this);
        info.renderPriceCat = this.renderPriceCat.bind(this);

        return <Category key={key} info={{ ...info, modePrice, parentItem }} />;
    }

    renderPriceItem(info) {
        const { modePrice, enableDrag, currentItems } = this.state;
        const id = info.id || info.tempId;

        info.saveChange = this.saveChange.bind(this);
        info.copyItem = this.copyItem.bind(this);
        info.deleteItem = this.deleteItem.bind(this);
        info.convertGroup = this.convertGroup.bind(this);
        info.onDragOver = this.onDragOver.bind(this, info.key);
        info.onDragStart = this.onDragStart.bind(this, info.key, id);
        info.onDrop = this.onDrop.bind(this);
        info.onEnableDrag = this.onEnableDrag.bind(this);
        info.onDisableDrag = this.onDisableDrag.bind(this);
        info.categoryTitle = currentItems.length ? currentItems[0].categoryTitle : "";

        return (
            <Row
                key={info.key}
                info={{ ...info, modePrice, enableDrag }} />
        );
    }

    renderMenuCat(info, i) {
        const { selectedMenu, modePrice } = this.state;
        const { openDialog } = this.props;
        const { name, items, code, id, tempId } = info;
        const prices = dt.getPrice();

        const sectionsId = prices?.[0]?.items?.length > 0 ? prices[0].items.map(it => +it.code) : [];

        const editInfo = {
            number: code,
            name: name,
            sectionsId: sectionsId,
            info: info
        };

        const valueId = id || tempId;

        return (
            <div
                key={"menuCat" + i}
                className={`rowMenu flex between rad4 ${selectedMenu === valueId ? "active" : ""}`}
                onClick={this.changeCurrentMenu.bind(this, valueId, (items || []))}>
                <div className="flex gap8 centerV">
                    {modePrice === "edit" && this.renderDragButt("rowMenu")}
                    <div className="text p1 gray">{code}</div>
                    <div className="name text p1SemiBold">{name}</div>
                </div>
                {modePrice === "edit" && <ButtonIconSelect
                    translate={true}
                    items={[
                        { name: "main.edit", onClick: openDialog.bind(this, "createSection", "edit", editInfo, this.changeNameSection.bind(this)) },
                        { name: "client.delete", onClick: this.deleteCat.bind(this, valueId) },
                    ]}
                />}
            </div>
        );
    }

    render() {
        const { modePrice, searchPlaceHolder, searchWord, currentItems, selectedMenu } = this.state;
        const { openDialog, renderStatus, root, currentInfo } = this.props;
        const { validity, status, id } = currentInfo;
        const edit = (!searchWord && modePrice === "edit");

        const prices = dt.getPrice();
        if (!prices)
            return null;

        const sectionsId = prices?.[0]?.items?.length > 0 ? prices[0].items.map(it => +it.code) : [];

        const items = prices[0] ? prices[0].items : [];
        const createInfo = {
            rootId: root.id,
            priceListId: id,
            sectionsId: sectionsId,
        };

        return (
            <div className="priceshow flex1 flex col gap16 pos rel">
                <div className="flex between">
                    <div className="flex gap16">
                        <ButtonIcon name="arrowLeft" onClick={this.onOutPrice.bind(this)} type="stroke" />
                        <div>
                            <div className="text blockTitle">
                                {`${modePrice === "view" ?
                                    this.tr("menu.price") :
                                    this.tr("price.priceListEdit")} ${validity ? validity : ""}`}
                            </div>
                            {<div className="text p2">
                                {renderStatus(status)}
                            </div>}
                        </div>
                    </div>
                    <div className="flex gap16">
                        <Search
                            ref={(el) => this.search = el}
                            itemStyle="search"
                            placeHolder={searchPlaceHolder}
                            onChange={this.changeState.bind(this, "searchWord")}
                            onFocus={this.changeState.bind(this, "searchPlaceHolder", "price.search")}
                            onBlur={this.changeState.bind(this, "searchPlaceHolder", "price.findPosition")}
                        />
                        <ButtonIconSelect
                            translate={true}
                            items={modePrice === "view" ? this.itemsViewPrice : this.itemsEditPrice}
                        />
                    </div>
                </div>
                <div className={`blockPrice flex flex1 ${searchWord ? "hide" : ""}`}>
                    <div className={`left transit04 flex col gap8 ${searchWord ? "hide" : ""}`}>
                        {edit && <><div className="flex end">
                            <div>
                                <ButtonIcon
                                    name="plus"
                                    onClick={openDialog.bind(this, "createSection", "create", createInfo, this.addSection.bind(this))} />
                            </div>
                        </div><div></div></>}
                        <div className={`flex pos rel ${edit ? "custom" : "flex1"}  scrolling`}>
                            <div className="w100 pos abs sideAll flex col gap8">
                                {items.map((it, i) => this.renderMenuCat(it, i))}
                            </div>
                        </div>
                    </div>
                    <div className={`right flex1 flex col gap16 ${searchWord ? "hide" : ""}`}>
                        {edit && <div className="flex end">
                            <div>
                                <AddNewItems
                                    categories={items}
                                    currentCategory={selectedMenu}
                                    startCode={currentItems.length}
                                    priceListId={id}
                                    hidCb={this.addItem.bind(this)}
                                />
                            </div>
                        </div>}
                        {!searchWord && selectedMenu &&
                            <div
                                ref={el => this.itemsPrice = el}
                                className={`itemsPriceCont flex ${edit ? "custom" : "flex1"} col pos rel scrolling`}>
                                <div className="w100 pos abs sideAll">
                                    {currentItems.length > 0 ?
                                        <div
                                            ref={el => this.contPrice = el}
                                            className="itemsPrice rad8">
                                            {currentItems.map((it, key) => this.renderPriceCat(it, key, prices[0]))}
                                        </div> : <div className="text p1">{this.tr("price.sectionEmpty")}</div>}
                                </div>
                            </div>}
                        {searchWord && <div className="itemsFindCont flex col flex1 pos rel scrolling">
                            <div className="w100 pos abs sideAll">
                                {this.renderFind()}
                            </div>
                        </div>}

                    </div>
                </div>
                {edit && <div className="blockSave flex between pos abs">
                    <div className="flex gap16">
                    </div>
                    <div className="flex gap16">
                        <Button
                            label="main.cancel"
                            size="small"
                            type="transparent"
                            onClick={this.onOutPrice.bind(this)}
                        />
                        <Button
                            label="main.save"
                            size="small"
                            onClick={this.savePriceList.bind(this)}
                        />
                    </div>
                </div>}
            </div>
        );
    }
}
